// Auto-generated from public/og
export const OG_IMAGE_SLUGS = new Set<string>([
  "appflowy",
  "appsmith",
  "calcom",
  "chatterbox",
  "chatwoot",
  "dify",
  "directus",
  "docuseal",
  "erpnext",
  "evolution-api",
  "ghost",
  "gitea",
  "gitlab",
  "invoiceninja",
  "jitsi",
  "listmonk",
  "mattermost",
  "meshcentral",
  "metabase",
  "moltbot",
  "moodle",
  "n8n",
  "nextcloud",
  "nocobase",
  "nocodb",
  "odoo",
  "open-webui",
  "openclaw",
  "openmrs",
  "paperless",
  "passbolt",
  "plane",
  "plausible",
  "shlink",
  "snipeit",
  "supabase",
  "superset",
  "tooljet",
  "twenty",
  "typebot",
  "uptime-kuma",
  "windrose",
  "woocommerce",
  "wordpress"
]);
